export default "__VITE_ASSET__SPXs6sM2__"